import { render, staticRenderFns } from "./TargetSKU.vue?vue&type=template&id=2abbcab2&scoped=true&"
import script from "./TargetSKU.vue?vue&type=script&lang=js&"
export * from "./TargetSKU.vue?vue&type=script&lang=js&"
import style0 from "./TargetSKU.vue?vue&type=style&index=0&id=2abbcab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abbcab2",
  null
  
)

export default component.exports